export const normalizePath = (path) =>
  // Rimuove le barre oblique all'inizio e alla fine
  path.replace(/\/+/g, '/').replace(/^\/|\/$/g, '');
